// extracted by mini-css-extract-plugin
module.exports = {"qanda":"index-module--qanda--1oKlU","question":"index-module--question--2oAOX","answer":"index-module--answer--3Fa5Y","flex":"index-module--flex--tcluA"};